// eha-lambda (AWS API Gateway), replaces the retired eagle-harbor-api Heroku app.
export const baseUrl = 'https://q60wcp0hqb.execute-api.us-east-1.amazonaws.com';

const Urls = {
  contactEmail: () => `${baseUrl}/contact`,
  setAppointmentEmail: () => `${baseUrl}/set-appointment`,
  submitRiskProfile: () => `${baseUrl}/submit-risk-profiler`,
}

export default Urls
